import * as React from 'react';
import { IContractDetail } from '../../logic';
import { Dispatch } from 'react';
import { SetStateAction } from 'react';

type TUpdateEditDetailStore = Dispatch<SetStateAction<IContractDetail>>;
type TEditDetailContext = [IContractDetail, TUpdateEditDetailStore];

export const EditDetailContext = React.createContext<TEditDetailContext>({} as TEditDetailContext);
